import AmicusRow from "./amicusRow";
import MatterRow from "./matter";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "./ui/card";
import { LoadingSpinner } from "./ui/loading-spinner";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "./ui/table";

import axios from "axios";
import { title } from "process";
import React, { useEffect, useState } from "react";
import { AmicusFile, Contact, Matter, MatterContactLink } from "src/lib/conflix";

const apiUrl = process.env.REACT_APP_API_URL;

function AmicusSheet(props: { idToken: string, usingRefNum: boolean, query: string, setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>, setAmicusFile: React.Dispatch<React.SetStateAction<AmicusFile | null>> }) {
  const [amicusFiles, setAmicusFiles] = useState<AmicusFile[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [spinner, setSpinner] = useState<boolean>(false);
  const [pro, setPro] = useState<boolean>(false);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    const fetchMatters = async () => {
        setSpinner(true);
      try {
        const featureResponse = await axios.get(
          `${apiUrl}feature/pro`,
          {
            headers: {
            "Authorization": props.idToken
            },

          }
        )

        setPro(featureResponse.status === 200);
        
        const response = await axios.get(
          `${apiUrl}amicus${props.query}`,
          {
            headers: {
            "Authorization": props.idToken
            },
            
          }
        );

        
        setAmicusFiles(response.data);
        
      } catch (error) {
        console.error("Error fetching matters:", error);
      }
      setSpinner(false);
    }

    fetchMatters();
  }, [loading]);

  const onUpdate = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${apiUrl}amicus${props.query}`,
        {
          headers: {
            "Authorization": props.idToken
          }
        }
      );
      setAmicusFiles(response.data);
    } catch (error) {
      console.error("Error fetching matters:", error);
    }
    setLoading(false);
  };

  const onLoading = (isLoading: boolean) => {
    setLoading(isLoading);
  }

  const onError = (err: string) => {
    setLoading(false);
    setError(err);
  }

  if (spinner) {
    return <div className="container mx-auto grid justify-items-center">
      <LoadingSpinner size={150} />
      <div>Loading...</div>
    </div>;
  }

  if (!pro) {
    return <div>
        <Card className="max-w-full overflow-auto mx-auto my-8">
      <CardHeader>
        <CardTitle>{`Amicus Results`}</CardTitle>
        <CardDescription className="text-red-600">{error}</CardDescription>
      </CardHeader>
      <CardContent>
        <u><a href="/account" className="text-blue-400">Upgrade to Pro to search imported files!</a></u>
      </CardContent>
    </Card>
    </div>
  }

  if (!amicusFiles || amicusFiles.length === 0 || props.usingRefNum) {
    return <div>
        <Card className="max-w-full overflow-auto mx-auto my-8">
      <CardHeader>
        <CardTitle>{`Amicus Results (0)`}</CardTitle>
        <CardDescription className="text-red-600">{error}</CardDescription>
      </CardHeader>
      <CardContent>
        <h1>No results</h1>
      </CardContent>
    </Card>
    </div>
  }

  return (
    
    <Card className="max-w-full overflow-auto mx-auto my-8">
      <CardHeader>
        <CardTitle>{`Amicus Results (${amicusFiles.length})`}</CardTitle>
        <CardDescription className="text-red-600">{error}</CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>File Name</TableHead>
              <TableHead>First Name</TableHead>
              <TableHead>Last Name</TableHead>
              <TableHead>Company</TableHead>
              <TableHead>Attorney First Name</TableHead>
              <TableHead>Attorney Last Name</TableHead>
              <TableHead>Created Date</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {amicusFiles?.map((object) => (
                <AmicusRow amicusFile={object} setAmicusFile={props.setAmicusFile} setDialogOpen={props.setDialogOpen}/>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}

export default AmicusSheet;